import { render, staticRenderFns } from "./AgentDealList.vue?vue&type=template&id=6d36aa7a&"
import script from "./AgentDealList.vue?vue&type=script&lang=ts&"
export * from "./AgentDealList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports